var CartContainerState = /** @class */ (function () {
    function CartContainerState() {
        this.loading = true;
        this.emptyCart = true;
        this.cartError = false;
        this.isExpressCart = false;
        this.autoExpandPromoSection = false;
        // DirecTvNow?: any;
        this.emptyCarts = {
            isDtvNowEmpty: false,
            isWirelessEmpty: false,
        };
        this.hideRetriveCartLink = false;
        this.showRetrieveModal = false;
        this.bannerMessages = [];
        this.allowedCMSGetCall = false;
    }
    return CartContainerState;
}());
export default CartContainerState;
//# sourceMappingURL=Cart.container.state.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/Cart/Cart.container.state.js
// module id = 2238
// module chunks = 8